import { v4 as uuid } from "uuid";
export const download = {
  namespaced: true,

  state: () => ({
    queue: [],
  }),

  getters: {
    hasActive: (state) => state.queue.length > 0,
  },

  mutations: {
    ADD(state, payload) {
      state.queue.push({
        id: payload.id,
        label: payload.label,
        progressText: "0 MB baixados",
        loadedBytes: 0,
        status: "downloading",
        controller: payload.controller,
      });
    },

    PROGRESS(state, { id, progressText, loadedBytes }) {
      const item = state.queue.find((u) => u.id === id);
      if (item) {
        item.progressText = progressText;
        item.loadedBytes = loadedBytes;
      }
    },

    FINISH(state, id) {
      const item = state.queue.find((u) => u.id === id);
      if (item) item.status = "done";
    },

    ERROR(state, id) {
      const item = state.queue.find((u) => u.id === id);
      if (item) item.status = "error";
    },

    CANCELED(state, id) {
      const item = state.queue.find((u) => u.id === id);
      if (item) item.status = "canceled";
    },

    REMOVE(state, id) {
      state.queue = state.queue.filter((u) => u.id !== id);
    },

    CLEAR(state) {
      state.queue = [];
    },
  },

  actions: {
    start({ commit }, payload) {
      const id = uuid();
      const controller = new AbortController();

      commit("ADD", { id, label: payload.label, controller });

      return { id, controller };
    },

    progress({ commit }, payload) {
      commit("PROGRESS", payload);
    },

    finish({ commit }, id) {
      commit("FINISH", id);
      setTimeout(() => commit("REMOVE", id), 15000);
    },

    error({ commit }, id) {
      commit("ERROR", id);
      setTimeout(() => commit("REMOVE", id), 30000);
    },

    cancelDownload({ state, commit }, id) {
      const item = state.queue.find((u) => u.id === id);
      if (!item) return;

      item.controller?.abort();
      commit("CANCELED", id);
      setTimeout(() => commit("REMOVE", id), 15000);
    },

    clearDownloads({ commit }) {
      commit("CLEAR");
    },
  },
};
